import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import { Link } from 'react-router';
import { startCase } from 'lodash';
import classNames from 'classnames';
import showBarrier from '../../../utils/showBarrier';

const PopoverLink = ({
    url, hash, tabName, className,
}) => (
    <Link
        to={`${url}/${tabName}${hash}`}
        className={classNames('pp-tabs__popoverLink',
            'ui-popoverList__item', className)}
        activeClassName="pp-tabs__popoverLink_selected"
        onClick={event => showBarrier(event, `${url}/${tabName}${hash}`)}
    >
        <span className="ui-popoverList__label">{startCase(tabName)}</span>
        <span className="ui-popoverList__icon">
            <Svg
                className="tableShowIcon"
                iconName="tick"
                size="Medium"
            />
        </span>
    </Link>
);

PopoverLink.propTypes = {
    url: PropTypes.string.isRequired,
    hash: PropTypes.string,
    tabName: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
};

export default PopoverLink;



// WEBPACK FOOTER //
// ./src/js/shared/nav/components/PopoverLink.jsx